import {
    CREATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    CREATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    CREATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_ACCESSORIES_INWARD_DETAILS_DK,
    DELETE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    DELETE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    DELETE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    ACCESSORIES_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    UPDATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    UPDATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_FAILURE_DK,
    FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_FAILURE_DK,
    ACCESSORIES_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './accessoriesInwardDetails.actionsType';

export const ACCESSORIES_INWARD_DETAILS_DK = 'accessoriesInwardDKDetails';

let initialState = {
    loading: false,
    accessoriesInwardDetailsById: [],
    accessoriesInwardDetails: [],
    previousGetList: [],
    isPoDetailsDisabled:[],
    accessoriesInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedFabricDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let accessoriesInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
        case FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
        case DELETE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardDetails: updatePayload
            };
        case FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardDetailsById: updatePayload
            };
        case FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.ACB
            };

        case CREATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: updatePayload,
                accessoriesInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: {},
                accessoriesInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false,
                selectedFabricDetails: {}
            };

        case FETCH_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case CREATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case DELETE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK:
        case FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardDetailsForm: {
                    ...state.accessoriesInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
            case ACCESSORIES_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
                return {
                    ...state,
                    isPoDetailsDisabled: payload
                };
        case ACCESSORIES_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                accessoriesInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false,
                selectedFabricDetails: {}
            };
        default:
            return state;
    }
};
